/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name  ControllerFaultCollDataSource
 * @description
 *     DataSource for ControllerFaultCollection. Extends LimitedListCollDataSource as it does not
 *     support pagination or search, and sets the update interval to 3 minutes.
 */
angular.module('aviApp').factory('ControllerFaultCollDataSource', [
'LimitedListCollDataSource', LimitedListCollDataSource => {
    return class ControllerFaultCollDataSource extends LimitedListCollDataSource {
        constructor(args) {
            super(args);
            this.updateInterval_ = 600;
            this.protectedUpdateInterval_ = true;
        }

        /** @override */
        getRequestParams_() {
            const params = super.getRequestParams_(this.params_);

            params.fields_ = _.map(this.fields_, field => field.id);

            return params;
        }
    };
}]);
